import type { ReactNode } from "react";
import { forwardRef } from "react";

import type { FieldErrorTextProps, FieldLabelProps } from "@chakra-ui/react";
import { Box, Field as ChakraField } from "@chakra-ui/react";

export type FieldProps = {
  label?: ReactNode;
  labelProps?: FieldLabelProps;
  helperText?: ReactNode;
  errorText?: ReactNode;
  errorTextProps?: FieldErrorTextProps;
  optionalText?: ReactNode;
} & Omit<ChakraField.RootProps, "label">;

export const Field = forwardRef<HTMLDivElement, FieldProps>(function Field(props, ref) {
  const { label, labelProps, children, helperText, errorText, errorTextProps, optionalText, ...rest } = props;

  return (
    <ChakraField.Root
      ref={ref}
      {...rest}
      position="relative"
    >
      {label && (
        <ChakraField.Label {...labelProps}>
          {label}
          <ChakraField.RequiredIndicator fallback={optionalText} />
        </ChakraField.Label>
      )}
      {children}
      {helperText && <ChakraField.HelperText>{helperText}</ChakraField.HelperText>}

      {errorText && (
        <Box
          position="absolute"
          top="100%"
          left="0"
          mt="2px"
          zIndex={1}
        >
          <ChakraField.ErrorText {...errorTextProps}>{errorText}</ChakraField.ErrorText>
        </Box>
      )}
    </ChakraField.Root>
  );
});
